import { render, staticRenderFns } from "./CommRentRR.vue?vue&type=template&id=649bcb61&scoped=true&"
import script from "./CommRentRR.vue?vue&type=script&lang=js&"
export * from "./CommRentRR.vue?vue&type=script&lang=js&"
import style0 from "./CommRentRR.vue?vue&type=style&index=0&id=649bcb61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649bcb61",
  null
  
)

export default component.exports